import * as fromDatatype from '../datatype-library/index';

export interface AddressJsonDto {
  city: string,
  name: string,
  state: string,
  status: string,
  country: string,
  addressType: 'BILLING_ADDRESS' | 'SHIPPING_ADDRESS' | 'MAIN_ADDRESS',
  postal_code: string,
  address_line_1: string,
  address_line_2?: string,
  address_line_3?: string,
  address_line_4?: string,
  address_line_5?: string,
  default_address_status: boolean,
  default_einvoice_address: boolean,
  receiver_name: string,
  mobile_no: string,
  email: string;
  longitude?: string;
  latitude?: string;
  phone_no?: string;
}

export interface DocEntityHdrJson {
  email: string,
  status: string,
  entityId: string,
  idNumber: string,
  salesLead: string,
  entityName: string,
  entityType: string,
  creditLimit: string,
  creditTerms: string,
  description: string,
  phoneNumber: string,
  identityType: string,
  currency: string
}

export interface EntityAddressJsonDatatypeInterface extends fromDatatype.JsonDatatypeInterface {
  billing_address?: AddressJsonDto[],
  shipping_address?: AddressJsonDto[],
  main_address?: AddressJsonDto[]
}

export interface bl_fi_entity_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  contact_key_guid: fromDatatype.GuidDataFieldInterface;
  id_no: fromDatatype.VarcharDatatypeInterface;
  id_type: fromDatatype.VarcharDatatypeInterface;
  phone: fromDatatype.VarcharDatatypeInterface;
  email: fromDatatype.VarcharDatatypeInterface;
  ref_1: fromDatatype.VarcharDatatypeInterface;
  ref_2: fromDatatype.VarcharDatatypeInterface;
  ref_3: fromDatatype.VarcharDatatypeInterface;
  ref_4: fromDatatype.VarcharDatatypeInterface;
  ref_5: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.VarcharDatatypeInterface;
  is_customer: boolean;
  is_supplier: boolean;
  is_employee: boolean;
  is_merchant: boolean;
  client_value: fromDatatype.VarcharDatatypeInterface;
  customer_code: fromDatatype.VarcharDatatypeInterface;
  supplier_code: fromDatatype.VarcharDatatypeInterface;
  merchant_code: fromDatatype.VarcharDatatypeInterface;
  employee_code: fromDatatype.VarcharDatatypeInterface;
  pgw_merchant_code: fromDatatype.VarcharDatatypeInterface;
  addresses_json: EntityAddressJsonDatatypeInterface;
  merchant_key: fromDatatype.VarcharDatatypeInterface;
  tax_reg_number: fromDatatype.VarcharDatatypeInterface;
  dob: fromDatatype.TimestampTzDatatypeInterface;
  gender: fromDatatype.VarcharDatatypeInterface;
  nationality: fromDatatype.VarcharDatatypeInterface;
  ethnicity: fromDatatype.VarcharDatatypeInterface;
  tax_category: fromDatatype.VarcharDatatypeInterface;
  language_code: fromDatatype.VarcharDatatypeInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  region_code: fromDatatype.VarcharDatatypeInterface;
  spending_limit_status: fromDatatype.VarcharDatatypeInterface;
  default_arap_type: fromDatatype.VarcharDatatypeInterface;
  country_alpha2_code: fromDatatype.VarcharDatatypeInterface;
  country_alpha3_code: fromDatatype.VarcharDatatypeInterface;
  status_01: fromDatatype.VarcharDatatypeInterface;
  status_02: fromDatatype.VarcharDatatypeInterface;
  marital_status: fromDatatype.VarcharDatatypeInterface;
  occupation: fromDatatype.VarcharDatatypeInterface;
  job_title: fromDatatype.VarcharDatatypeInterface;
  job_industry: fromDatatype.VarcharDatatypeInterface;
  job_role: fromDatatype.VarcharDatatypeInterface;
  job_skills: fromDatatype.JsonDatatypeInterface;
  merchant_key_2: fromDatatype.VarcharDatatypeInterface;
  merchant_secret_2: fromDatatype.VarcharDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  phone_status: fromDatatype.VarcharDatatypeInterface;
  income_level: fromDatatype.VarcharDatatypeInterface;
  pricing_scheme_hdr_guid: fromDatatype.GuidDataFieldInterface;
  epf_no: fromDatatype.VarcharDatatypeInterface;
  old_mbs_icno: fromDatatype.VarcharDatatypeInterface;
  old_mbs_hand_phone: fromDatatype.VarcharDatatypeInterface;
  old_mbs_home_phone: fromDatatype.VarcharDatatypeInterface;
  old_mbs_office_phone: fromDatatype.VarcharDatatypeInterface;
  old_mbs_email: fromDatatype.VarcharDatatypeInterface;
  old_sso_icno: fromDatatype.VarcharDatatypeInterface;
  old_sso_phone: fromDatatype.VarcharDatatypeInterface;
  old_sso_email: fromDatatype.VarcharDatatypeInterface;
  business_nature_code: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  id_no_old: fromDatatype.VarcharDatatypeInterface;
  classification: fromDatatype.VarcharDatatypeInterface;
  fiscal_year_end_month: fromDatatype.IntegerDatatypeInterface;
  website_url: fromDatatype.VarcharDatatypeInterface;
  join_date: fromDatatype.TimestampTzDatatypeInterface;
  resign_date: fromDatatype.TimestampTzDatatypeInterface;
  gst_number: fromDatatype.VarcharDatatypeInterface;
  wht_tax_number: fromDatatype.VarcharDatatypeInterface;
  alternate_tax_no_1: fromDatatype.VarcharDatatypeInterface;
  alternate_tax_no_2: fromDatatype.VarcharDatatypeInterface;
  supplier_lifecycle_status_code: fromDatatype.VarcharDatatypeInterface;
  merchant_lifecycle_status_code: fromDatatype.VarcharDatatypeInterface;
  customer_lifecycle_status_code: fromDatatype.VarcharDatatypeInterface;
  employee_lifecycle_status_code: fromDatatype.VarcharDatatypeInterface;
  default_org_chart_hdr_guid: fromDatatype.GuidDataFieldInterface;
  default_comp_guid: fromDatatype.GuidDataFieldInterface;
  default_branch_guid: fromDatatype.GuidDataFieldInterface;
  default_location_guid: fromDatatype.GuidDataFieldInterface;
  default_division: fromDatatype.VarcharDatatypeInterface;
  default_department: fromDatatype.VarcharDatatypeInterface;
  default_team_name: fromDatatype.VarcharDatatypeInterface;
  job_type: fromDatatype.VarcharDatatypeInterface;
  xtn_manager_email: fromDatatype.VarcharDatatypeInterface;
  xtn_job_title: fromDatatype.VarcharDatatypeInterface;
  xtn_job_level_name: fromDatatype.VarcharDatatypeInterface;
  xtn_job_type: fromDatatype.VarcharDatatypeInterface;
  xtn_organization: fromDatatype.VarcharDatatypeInterface;
  xtn_division: fromDatatype.VarcharDatatypeInterface;
  xtn_department: fromDatatype.VarcharDatatypeInterface;
  xtn_team_name: fromDatatype.VarcharDatatypeInterface;
  xtn_location_code: fromDatatype.VarcharDatatypeInterface;
  sic_code: fromDatatype.VarcharDatatypeInterface;
  business_activity_desc: fromDatatype.TextDatatypeInterface;
  xtn_report_to_01_email: fromDatatype.VarcharDatatypeInterface;
  xtn_report_to_01_name: fromDatatype.VarcharDatatypeInterface;
  xtn_report_to_01_employee_code: fromDatatype.VarcharDatatypeInterface;
  xtn_report_to_01_guid: fromDatatype.GuidDataFieldInterface;
  xtn_report_to_02_email: fromDatatype.VarcharDatatypeInterface;
  xtn_report_to_02_name: fromDatatype.VarcharDatatypeInterface;
  xtn_report_to_02_employee_code: fromDatatype.VarcharDatatypeInterface;
  xtn_report_to_02_guid: fromDatatype.GuidDataFieldInterface;
  xtn_report_to_03_email: fromDatatype.VarcharDatatypeInterface;
  xtn_report_to_03_name: fromDatatype.VarcharDatatypeInterface;
  xtn_report_to_03_employee_code: fromDatatype.VarcharDatatypeInterface;
  xtn_report_to_03_guid: fromDatatype.GuidDataFieldInterface;
  default_approval_rank: fromDatatype.IntegerDatatypeInterface;
  id_no_expiry_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  default_sales_agent: fromDatatype.GuidDataFieldInterface;
  default_sales_agent_code: fromDatatype.VarcharDatatypeInterface;
  default_label_guid: fromDatatype.GuidDataFieldInterface;
  default_label_code: fromDatatype.VarcharDatatypeInterface;
  sst_number: fromDatatype.VarcharDatatypeInterface;
  einvoice_tax_id_no: fromDatatype.VarcharDatatypeInterface;
  tourism_tax_id: fromDatatype.VarcharDatatypeInterface;
  einvoice_default_payment_method_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_default_payment_method_json: any;
  einvoice_self_billed: fromDatatype.VarcharDatatypeInterface;
  default_purchase_return_pricing_option: fromDatatype.VarcharArrayDatatypeInterface;
  default_sales_return_pricing_option: fromDatatype.VarcharArrayDatatypeInterface;
  einvoice_id_type: fromDatatype.VarcharDatatypeInterface;
  einvoice_id_value: fromDatatype.VarcharDatatypeInterface;
  peppol_participant_id: fromDatatype.VarcharDatatypeInterface;
  nickname: fromDatatype.VarcharDatatypeInterface;
  einvoice_notification_methods_json: any;
  skip_einvoice: boolean;
  client_updated_date: fromDatatype.TimestampTzDatatypeInterface;
  consolidated_arap_guid: fromDatatype.GuidDataFieldInterface;
  alert_message: fromDatatype.TextDatatypeInterface;
  credit_limit_status: fromDatatype.VarcharDatatypeInterface;
  credit_term_status: fromDatatype.VarcharDatatypeInterface;
  default_sales_credit_limit_guid: fromDatatype.GuidDataFieldInterface;
  default_sales_credit_term_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_fi_entity_hdr_RowClass
  implements bl_fi_entity_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  contact_key_guid: fromDatatype.GuidDataFieldInterface;
  id_no: fromDatatype.VarcharDatatypeInterface;
  id_type: fromDatatype.VarcharDatatypeInterface;
  phone: fromDatatype.VarcharDatatypeInterface;
  email: fromDatatype.VarcharDatatypeInterface;
  ref_1: fromDatatype.VarcharDatatypeInterface;
  ref_2: fromDatatype.VarcharDatatypeInterface;
  ref_3: fromDatatype.VarcharDatatypeInterface;
  ref_4: fromDatatype.VarcharDatatypeInterface;
  ref_5: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.VarcharDatatypeInterface;
  is_customer: boolean;
  is_supplier: boolean;
  is_employee: boolean;
  is_merchant: boolean;
  client_value: fromDatatype.VarcharDatatypeInterface;
  customer_code: fromDatatype.VarcharDatatypeInterface;
  supplier_code: fromDatatype.VarcharDatatypeInterface;
  merchant_code: fromDatatype.VarcharDatatypeInterface;
  employee_code: fromDatatype.VarcharDatatypeInterface;
  pgw_merchant_code: fromDatatype.VarcharDatatypeInterface;
  addresses_json: EntityAddressJsonDatatypeInterface;
  merchant_key: fromDatatype.VarcharDatatypeInterface;
  tax_reg_number: fromDatatype.VarcharDatatypeInterface;
  dob: fromDatatype.TimestampTzDatatypeInterface;
  gender: fromDatatype.VarcharDatatypeInterface;
  nationality: fromDatatype.VarcharDatatypeInterface;
  ethnicity: fromDatatype.VarcharDatatypeInterface;
  tax_category: fromDatatype.VarcharDatatypeInterface;
  language_code: fromDatatype.VarcharDatatypeInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  region_code: fromDatatype.VarcharDatatypeInterface;
  spending_limit_status: fromDatatype.VarcharDatatypeInterface;
  default_arap_type: fromDatatype.VarcharDatatypeInterface;
  country_alpha2_code: fromDatatype.VarcharDatatypeInterface;
  country_alpha3_code: fromDatatype.VarcharDatatypeInterface;
  status_01: fromDatatype.VarcharDatatypeInterface;
  status_02: fromDatatype.VarcharDatatypeInterface;
  marital_status: fromDatatype.VarcharDatatypeInterface;
  occupation: fromDatatype.VarcharDatatypeInterface;
  job_title: fromDatatype.VarcharDatatypeInterface;
  job_industry: fromDatatype.VarcharDatatypeInterface;
  job_role: fromDatatype.VarcharDatatypeInterface;
  job_skills: fromDatatype.JsonDatatypeInterface;
  merchant_key_2: fromDatatype.VarcharDatatypeInterface;
  merchant_secret_2: fromDatatype.VarcharDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  phone_status: fromDatatype.VarcharDatatypeInterface;
  income_level: fromDatatype.VarcharDatatypeInterface;
  pricing_scheme_hdr_guid: fromDatatype.GuidDataFieldInterface;
  epf_no: fromDatatype.VarcharDatatypeInterface;
  old_mbs_icno: fromDatatype.VarcharDatatypeInterface;
  old_mbs_hand_phone: fromDatatype.VarcharDatatypeInterface;
  old_mbs_home_phone: fromDatatype.VarcharDatatypeInterface;
  old_mbs_office_phone: fromDatatype.VarcharDatatypeInterface;
  old_mbs_email: fromDatatype.VarcharDatatypeInterface;
  old_sso_icno: fromDatatype.VarcharDatatypeInterface;
  old_sso_phone: fromDatatype.VarcharDatatypeInterface;
  old_sso_email: fromDatatype.VarcharDatatypeInterface;
  business_nature_code: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  id_no_old: fromDatatype.VarcharDatatypeInterface;
  classification: fromDatatype.VarcharDatatypeInterface;
  fiscal_year_end_month: fromDatatype.IntegerDatatypeInterface;
  website_url: fromDatatype.VarcharDatatypeInterface;
  join_date: fromDatatype.TimestampTzDatatypeInterface;
  resign_date: fromDatatype.TimestampTzDatatypeInterface;
  gst_number: fromDatatype.VarcharDatatypeInterface;
  wht_tax_number: fromDatatype.VarcharDatatypeInterface;
  alternate_tax_no_1: fromDatatype.VarcharDatatypeInterface;
  alternate_tax_no_2: fromDatatype.VarcharDatatypeInterface;
  supplier_lifecycle_status_code: fromDatatype.VarcharDatatypeInterface;
  merchant_lifecycle_status_code: fromDatatype.VarcharDatatypeInterface;
  customer_lifecycle_status_code: fromDatatype.VarcharDatatypeInterface;
  employee_lifecycle_status_code: fromDatatype.VarcharDatatypeInterface;
  default_org_chart_hdr_guid: fromDatatype.GuidDataFieldInterface;
  default_comp_guid: fromDatatype.GuidDataFieldInterface;
  default_branch_guid: fromDatatype.GuidDataFieldInterface;
  default_location_guid: fromDatatype.GuidDataFieldInterface;
  default_division: fromDatatype.VarcharDatatypeInterface;
  default_department: fromDatatype.VarcharDatatypeInterface;
  default_team_name: fromDatatype.VarcharDatatypeInterface;
  job_type: fromDatatype.VarcharDatatypeInterface;
  xtn_manager_email: fromDatatype.VarcharDatatypeInterface;
  xtn_job_title: fromDatatype.VarcharDatatypeInterface;
  xtn_job_level_name: fromDatatype.VarcharDatatypeInterface;
  xtn_job_type: fromDatatype.VarcharDatatypeInterface;
  xtn_organization: fromDatatype.VarcharDatatypeInterface;
  xtn_division: fromDatatype.VarcharDatatypeInterface;
  xtn_department: fromDatatype.VarcharDatatypeInterface;
  xtn_team_name: fromDatatype.VarcharDatatypeInterface;
  xtn_location_code: fromDatatype.VarcharDatatypeInterface;
  sic_code: fromDatatype.VarcharDatatypeInterface;
  business_activity_desc: fromDatatype.TextDatatypeInterface;
  xtn_report_to_01_email: fromDatatype.VarcharDatatypeInterface;
  xtn_report_to_01_name: fromDatatype.VarcharDatatypeInterface;
  xtn_report_to_01_employee_code: fromDatatype.VarcharDatatypeInterface;
  xtn_report_to_01_guid: fromDatatype.GuidDataFieldInterface;
  xtn_report_to_02_email: fromDatatype.VarcharDatatypeInterface;
  xtn_report_to_02_name: fromDatatype.VarcharDatatypeInterface;
  xtn_report_to_02_employee_code: fromDatatype.VarcharDatatypeInterface;
  xtn_report_to_02_guid: fromDatatype.GuidDataFieldInterface;
  xtn_report_to_03_email: fromDatatype.VarcharDatatypeInterface;
  xtn_report_to_03_name: fromDatatype.VarcharDatatypeInterface;
  xtn_report_to_03_employee_code: fromDatatype.VarcharDatatypeInterface;
  xtn_report_to_03_guid: fromDatatype.GuidDataFieldInterface;
  default_approval_rank: fromDatatype.IntegerDatatypeInterface;
  id_no_expiry_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  default_sales_agent: fromDatatype.GuidDataFieldInterface;
  default_sales_agent_code: fromDatatype.VarcharDatatypeInterface;
  default_label_guid: fromDatatype.GuidDataFieldInterface;
  default_label_code: fromDatatype.VarcharDatatypeInterface;
  sst_number: fromDatatype.VarcharDatatypeInterface;
  einvoice_tax_id_no: fromDatatype.VarcharDatatypeInterface;
  tourism_tax_id: fromDatatype.VarcharDatatypeInterface;
  einvoice_default_payment_method_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_default_payment_method_json: any;
  einvoice_self_billed: fromDatatype.VarcharDatatypeInterface;
  default_purchase_return_pricing_option: fromDatatype.VarcharArrayDatatypeInterface;
  default_sales_return_pricing_option: fromDatatype.VarcharArrayDatatypeInterface;
  einvoice_id_type: fromDatatype.VarcharDatatypeInterface;
  einvoice_id_value: fromDatatype.VarcharDatatypeInterface;
  peppol_participant_id: fromDatatype.VarcharDatatypeInterface;
  nickname: fromDatatype.VarcharDatatypeInterface;
  einvoice_notification_methods_json: any;
  skip_einvoice: boolean;
  client_updated_date: fromDatatype.TimestampTzDatatypeInterface;
  consolidated_arap_guid: fromDatatype.GuidDataFieldInterface;
  alert_message: fromDatatype.TextDatatypeInterface;
  credit_limit_status: fromDatatype.VarcharDatatypeInterface;
  credit_term_status: fromDatatype.VarcharDatatypeInterface;
  default_sales_credit_limit_guid: fromDatatype.GuidDataFieldInterface;
  default_sales_credit_term_guid: fromDatatype.GuidDataFieldInterface;
}
